import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation } from 'react-router-dom';

import MainMeta from '../../metaTags/MainMeta';
import ButtonLink from "../../components/Button";

import "../../style/title.scss";
import "./index.scss";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function StatusSuccess(){
  const { t } = useTranslation();
  const { lang } = useParams(); // Получаем текущий язык из URL
  const query = useQuery();
  const invitees = parseInt(query.get('invitees')) || 1;
  const date = query.get('date') || '';
  const time = query.get('time') || '';
  return(
        <div className="success-wrapper">
          <MainMeta />
          <div className='title'>
              <div className='text big'>{t('thanks')}</div>
              {/* <div className='text desktop'>{t('thanks-description')}</div>
              <div className='text mobile'><span>{t('thanks-description-part1')}</span><span>{t('thanks-description-part2')}</span></div> */}
              <div className='text desktop'>
                {invitees <= 4
                ? `${t('success-page-4-guests')} ${date} ${t('success-page-preposition')} ${time}${t('success-page-4-guests-second-part')}`
                : `${t('success-page-more-guests')}`}
                </div>
              <div className='text mobile'>
                {invitees <= 4
                ? `${t('success-page-4-guests')} ${date} ${t('success-page-preposition')} ${time}${t('success-page-4-guests-second-part')}`
                : `${t('success-page-more-guests')}`}
                </div>
          </div>
        </div>
    )
}
export default StatusSuccess; 


